import React, { useEffect, useState } from "react";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import { Grid, MenuItem, Typography } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { NavigateFunction, useNavigate } from "react-router-dom";
import FilterSelect from "../../../components/select/filterSelect";
import CardChat from "../../../components/card/CardChat";
import CustomStatus from "../../../components/chip/CustomStatus";
import { FiberManualRecord } from "@mui/icons-material";
import InputTextField from "../../../components/input/inputTextField";
import { useDispatch, useSelector } from "react-redux";
import { advisorStudentApi } from "../../../api/advisor-student/advisor-student.api";
import { dataEvaluation } from "../../../utils/usage_form_evluation";
import AutocompleteSelect from "../../../components/select/autoCompleteSelect";
import {
  handleColorStatusConsultRequestUtil,
  handleTextStatusConsultRequestUtil,
} from "../../../utils/statusRequest";
import VotingEvaluation from "./VotingEvaluationReport";
import { advisorTypeApi } from "../../../api/advisor-type/advisor-type.api";
import { advisorApi } from "../../../api/advisor/advisor.api";
import { EmployeeApi } from "../../../api/employee/employee.api";
import { facultyApi } from "../../../api/factulty/factulty.api";

const ExportReportConsultationRequestDetail = () => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { profile } = useSelector((state: any) => state.profile);
  const { id, token } = useParams();

  const queryParams = new URLSearchParams(location.search);
  const grade_level = queryParams.get("grade_level");
  const faculty_name = queryParams.get("faculty_name");

  const [singleDataStudent, setSingleDataStudent] = useState<any>({});

  const [inputValue, setInputValue] = useState({
    selected_usage_type: "",
    selected_advisor_type: 0,
    selected_advisor_type_name: "",
    selected_advisor_id: 0,
    selected_employee_id: 0,
    selected_faculty_id: 0,
    detail: "",
    new_message: "",
    //
    status: "",
    last_updated_by: "",
  });

  const [singleData, setSingleData] = useState<any>({});
  const [faculty, setFaculty] = useState<any[]>([]);

  const [chatDetail, setChatDetail] = useState<any[]>([]);

  const [dataAdvisorType, setDataAdvisorType] = useState<any[]>([]);
  const [dataAdvisor, setDataAdvisor] = useState<any[]>([]);
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const [isNewRequest, setIsNewRequest] = useState(false);

  const getAdvisorType = async (token: string) => {
    const res = await advisorTypeApi.getAllAdvisorType({}, token);

    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorType(data.data.items);
    } else {
      setDataAdvisorType([]);
    }
  };

  const getDataAdvisor = async (token: string) => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await advisorApi.getAllAdvisor(query, token);
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisor(data.data.items);
    } else {
      setDataAdvisor([]);
    }
  };

  const getDataEmployee = async (token: string) => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await EmployeeApi.list(query, token);
    const data = res.data;
    if (data.status < 300) {
      setDataEmployee(data.data.items);
    } else {
      setDataEmployee([]);
    }
  };

  const getFaculty = async (token: string) => {
    const res = await facultyApi.getAllFaculty({},token);

    const data = res.data;
    if (data.status < 300) {
      setFaculty(data.data);
    } else {
      setFaculty([]);
    }
  };

  useEffect(() => {
    if (token) {
      getAdvisorType(token);
      getDataAdvisor(token);
      getDataEmployee(token);
      getFaculty(token);
    }
  }, [token]);

  const handleChangeValue = (name: string, value: any) => {
    setInputValue((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getSingleDataConsultation = async (id: number, token: string) => {
    if (token) {
      const res = await advisorStudentApi.getAdvisorStudentById(id, token);
      const data = res.data;
      console.log("res", res);
      if (data.status < 300) {
        let parsedAdvisorStudentDetail = {} as any;

        try {
          parsedAdvisorStudentDetail = JSON.parse(
            data?.data.advisor_student_detaill
          );
        } catch (error) {
          console.error("Error parsing advisor_student_detaill:", error);
        }

        setSingleDataStudent(data.data?.student);

        setInputValue({
          selected_usage_type: data.data?.advisor_group ?? "-",
          selected_advisor_type: parsedAdvisorStudentDetail?.advisor_type ?? 0,
          selected_advisor_type_name:
            parsedAdvisorStudentDetail?.advisor_type_name ?? "-",
          selected_advisor_id: data.data?.id_advisor ?? "-",
          selected_employee_id: data.data?.id_employee ?? "-",
          selected_faculty_id: parsedAdvisorStudentDetail.faculty_id ?? "-",
          detail: parsedAdvisorStudentDetail.detail ?? "-",
          new_message: "",
          status: parsedAdvisorStudentDetail.status ?? "",
          last_updated_by: parsedAdvisorStudentDetail.last_updated_by ?? "",
        });
        setSingleData(parsedAdvisorStudentDetail);

        const fileData = data.data.advisorStudentFile ?? [];
        const chatData = parsedAdvisorStudentDetail.chat;

        const mergedData = [
          // Map chat data
          ...chatData.map((chat: any) => ({
            chat_id: chat.chat_id,
            chat_type: chat.chat_type,
            message: chat.message,
            send_date: chat.send_date,
            send_by: chat.send_by,
            send_to: chat.send_to,
            content_type: "text",
            file: null,
          })),
          // Map file data
          ...fileData.map((file: any) => ({
            chat_id: file.id_advisor_student_file,
            chat_type: "file",
            message: null,
            send_date: file.created_date,
            send_by: file.created_id,
            send_to: null, // Use the same `send_to` as chat
            content_type: "file",
            file,
          })),
        ];

        const uniqueMergedData = mergedData.reduce((acc, item) => {
          // Check if the chat_id already exists in the accumulator
          if (
            !acc.some(
              (existingItem: any) => existingItem.chat_id === item.chat_id
            )
          ) {
            acc.push(item); // Add item if it's not a duplicate
          }
          return acc;
        }, []);

        setChatDetail(uniqueMergedData ?? []);
      } else {
        setInputValue({
          selected_usage_type: "",
          selected_advisor_type: 0,
          selected_advisor_type_name: "",
          selected_advisor_id: 0,
          selected_employee_id: 0,
          selected_faculty_id: 0,
          detail: "",
          new_message: "",
          status: "",
          last_updated_by: "",
        });
        setSingleData({});
        setChatDetail([]);
      }
    }
  };

  useEffect(() => {
    if (id && token) {
      getSingleDataConsultation(+id, token);
    }
  }, [id, token]);

  return (
    <div
      style={{
        padding: "24px",
      }}
    >
      <div className="h-auto">
        {/* header */}
        <section className="my-4 flex justify-between">
          <Typography variant="h3">
            ส่งเรื่องขอคำปรึกษา{" "}
            <CustomStatus
              label={handleColorStatusConsultRequestUtil(
                inputValue?.status,
                profile && profile.user_type
              )}
              type="outlined"
              color={handleTextStatusConsultRequestUtil(inputValue?.status)}
              icon={<FiberManualRecord />}
              width="250px"
            />
          </Typography>
        </section>
        <div style={{ background: "#fff", padding: "16px" }}>
          <Grid container spacing={2} alignItems="starts">
            <Grid item xs={12} sm={12}>
              <Typography variant="subtitle1">
                ชื่อ - นามสกุล :{" "}
                {(singleDataStudent &&
                  singleDataStudent.student_frist_name +
                    " " +
                    singleDataStudent.student_last_name) ??
                  ""}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Typography variant="subtitle1">
                ฉายา :{" "}
                {(singleDataStudent && singleDataStudent.student_middle_name) ??
                  ""}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Typography variant="subtitle1">
                รหัสประจำตัวนักศึกษา :{" "}
                {(singleDataStudent && singleDataStudent.student_no) ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Typography variant="subtitle1">
                ชั้นปีที่ :{grade_level ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Typography variant="subtitle1">
                หลักสูตร : {faculty_name ?? ""}
              </Typography>
            </Grid>
          </Grid>

          <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
            <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
              <FilterSelect
                heading={"เลือกประเภท"}
                value={inputValue.selected_usage_type ?? ""}
                labelId="type-id"
                selectId="type-select-id"
                options={[
                  {
                    id_type: "",
                    type_name: "เลือกประเภท",
                  },
                  ...dataEvaluation.map((list) => ({
                    id_type: list.id,
                    type_name: list.name,
                  })),
                ].map((list, index) => (
                  <MenuItem value={list.id_type} key={index + 1}>
                    {list.type_name}
                  </MenuItem>
                ))}
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeValue("selected_usage_type", e.target.value)
                }
                disabled
              />
            </article>

            {inputValue &&
              inputValue.selected_usage_type ===
                "อาจารย์ที่ปรึกษาประจำชั้น" && (
                <>
                  <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
                    <InputTextField
                      heading={"ประเภทคำปรึกษา"}
                      value={inputValue.selected_advisor_type_name}
                      disabled
                    />
                  </article>

                  <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
                    <AutocompleteSelect
                      heading={"อาจารย์ที่ต้องการปรึกษา"}
                      freeSolo
                      labelId={"-"}
                      options={dataAdvisor ?? []}
                      getOptionLabel={(option: any) =>
                        inputValue.selected_advisor_id &&
                        dataAdvisor &&
                        dataAdvisor.length > 0
                          ? dataAdvisor.find(
                              (data: any) =>
                                data.id_advisor ===
                                inputValue.selected_advisor_id
                            )?.first_name +
                            " " +
                            dataAdvisor.find(
                              (data: any) =>
                                data.id_advisor ===
                                inputValue.selected_advisor_id
                            )?.last_name
                          : ""
                      }
                      value={"-"}
                      disabled
                    />
                  </article>
                </>
              )}

            {inputValue &&
              inputValue.selected_usage_type ===
                "อาจารย์ที่ปรึกษาประจำรายวิชา" && (
                <>
                  <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12"></article>

                  <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
                    <AutocompleteSelect
                      heading={"รายวิชา"}
                      freeSolo
                      labelId={"-"}
                      options={faculty ?? []}
                      value={
                        faculty.find(
                          (x: any) =>
                            x?.id_faculty === inputValue.selected_faculty_id
                        ) || null
                      }
                      getOptionLabel={(option: any) =>
                        `${option?.faculty_name}` || ""
                      }
                      renderOption={(props, option) => (
                        <li {...props}>{`${option?.faculty_name}`}</li>
                      )}
                      disabled
                    />
                  </article>

                  <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
                    <InputTextField
                      heading={"อาจารย์ที่ต้องการปรึกษา"}
                      // value={dataEmployee}
                      value={
                        dataEmployee.find(
                          (x: any) =>
                            x?.id_employee === inputValue.selected_employee_id
                        )?.fullname || null
                      }
                      disabled
                    />
                  </article>
                </>
              )}

            <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 mt-4">
              <CardChat
                data={
                  (chatDetail &&
                    chatDetail?.map((item: any, index: number) => ({
                      id: item.chat_id,
                      type:
                        item.chat_type === "student"
                          ? "นักศึกษา"
                          : "อาจารย์ที่ปรึกษา",
                      sender: item.chat_type !== "student" ? "me" : "you",
                      message: item.message,
                      date: item.send_date,
                      content_type: item.content_type,
                      file: item.file,
                    }))) ??
                  []
                }
                isAll
              />
            </article>

            {isNewRequest && (
              <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
                <InputTextField
                  heading={"รายละเอียด"}
                  placeholder={"ระบุรายละเอียด"}
                  value={inputValue.new_message}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChangeValue("new_message", e.target.value)
                  }
                  row={3}
                  maxRows={5}
                  disablePaddingMultiline
                  multiline
                  inputHeight={"auto"}
                />
              </article>
            )}
          </div>

          <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 mt-4">
            <VotingEvaluation id={id ? +id : 0} isAll token={token} />
          </article>
        </div>
      </div>
    </div>
  );
};

export default ExportReportConsultationRequestDetail;
